<template>
  <div
    :class="{ 'is-selected': isSelected }"
    class="boss-vertical-menu-item"
    @click="show"
  >
    <div
      v-tooltip="{ content: '新しく会員がヒットした場合にお知らせする検索条件を、３つ選択できます。'}"
      class="pega-fav-icon"
      data-test="fav-icon"
      @click.stop="$emit('updateOften', searchCondition.id ,searchCondition.isOftenUse)"
    >
      <span
        class="boss-icon"
        :class="[searchCondition.isOftenUse ? 'boss-icon-bell-solid' : 'boss-icon-bell-regular']"
        data-test="icon"
      />
    </div>
    <span
      :data-test="'search-condition-name-' + searchCondition.id"
      class="pega-break"
    >{{ searchCondition.name }}</span>
    <span
      v-if="searchCondition.isNew"
      data-test="new"
      class="boss-notify-count"
    >NEW</span>
    <div
      :class="{ 'is-open': isOpen }"
      class="boss-vertical-menu-item-context boss-context-menu"
    >
      <div
        class="boss-context-menu-toggler"
        @click.stop="toggle"
      />
      <div
        class="boss-context-menu-closer"
        @click.stop="close"
      />
      <div class="boss-context-menu-list">
        <template v-for="(item, key) in menu">
          <div
            :key="key"
            :data-test="'search-condition-' + item.name + '-' + searchCondition.id"
            class="boss-context-menu-list-item"
            @click.stop="item.action(); close();"
          >
            {{ item.title }}
          </div>
        </template>
      </div>
    </div>
    <!-- ▼その他求人コピーモーダル -->
    <div
      :id="`other-copy-modal-${searchCondition.id}`"
      class="reveal boss-modal-container pega-modal-position"
      data-reveal
    >
      <h1
        class="boss-page-title boss-page-title-layout-title pega-mb-25"
        data-test="modal-title"
      >
        検索条件を他求人にコピー
      </h1>
      <div class="boss-layout boss-layout-center">
        <div class="pega-bulk-update-container">
          <div data-test="modal-body">
            選択した求人に{{ searchCondition.name }}の検索条件をコピー
          </div>
          <div>
            <select
              v-model="copyToJobId"
              data-test="input-select"
              class="boss-input-select"
            >
              <option
                data-test="no-selected"
                value=""
              >
                選択してください
              </option>
              <option
                v-for="(job ,i) in optionJobs"
                :key="i"
                :data-test="`item-option-${searchCondition.id}-${job.id}`"
                :value="job.id"
              >
                {{ job.managementName }}
              </option>
            </select>
          </div>
          <div class="text-center">
            <button
              :disabled="!copyToJobId"
              class="float-center boss-button-center boss-button-large pega-button pega-mr-20"
              type="button"
              data-test="update-button"
              @click.stop="otherJobCopy"
            >
              コピーする
            </button>
            <button
              class="float-center boss-button-center boss-button-large"
              type="button"
              data-test="cancel-button"
              @click.stop="closeReveal()"
            >
              キャンセル
            </button>
          </div>
        </div>
      </div>
      <button
        class="close-button boss-close-button boss-icon-cross"
        data-close
        aria-label="Close modal"
        type="button"
        @click.stop="closeReveal()"
      />
    </div>
    <!-- ▲その他求人コピーモーダル -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { createDefaultCondition } from '@/model/searchDataModel'
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
export default {
  props: {
    jobId: {
      type: Number,
      default: null
    },
    searchCondition: {
      type: Object,
      default: () => ({
        id: '',
        name: '',
        isOftenUse: false,
        isNew: false
      })
    },
    contractId: {
      type: Number,
      default: null
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      menu: [
        {
          title: '編集',
          name: 'edit',
          action: this.edit
        },
        {
          title: 'コピー',
          name: 'copy',
          action: this.copy
        },
        {
          title: '他求人にコピー',
          name: 'other-copy',
          action: this.showModal
        },
        {
          title: '削除',
          name: 'delete',
          action: this.doRemove
        }
      ],
      copyToJobId: ''
    }
  },
  computed: {
    ...mapGetters('contracts', [
      'publishedJobsBy',
      'jobBy'
    ]),
    optionJobs () {
      return this.publishedJobsBy(this.contractId).filter(job => job.id !== this.jobId)
    }
  },
  beforeDestroy () {
    jQuery('html').removeClass('is-reveal-open')
  },
  methods: {
    show () {
      this.fetchSearchCondition().then(response => {
        this.$store.dispatch('setMembersSearchCondition', { jobId: this.jobId, membersSearchCondition: this.responseMappingSearchCondition(response.data) })
        this.$emit('onRead', this.searchCondition.id)
      })
    },
    edit () {
      this.fetchSearchCondition().then().then(response => {
        this.$store.dispatch('setMembersSearchCondition', { jobId: this.jobId, membersSearchCondition: this.responseMappingSearchCondition(response.data) })
        this.$router.push(`/scouts/contracts/${this.contractId}/jobs/${this.jobId}/users/search`)
      })
    },
    copy () {
      this.$http.secured.post(`/scout/view/scouts/search_conditions/${this.searchCondition.id}/_copy`).then((response) => {
        this.$toasted.global.success({ message: '検索条件をコピーしました。' })
        this.fetchSearchConditions()
      })
    },
    remove () {
      this.$http.secured.delete(`/scout/view/scouts/search_conditions/${this.searchCondition.id}`).then((response) => {
        if (this.isSelected) {
          // storeに保存されている検索条件を削除
          this.deleteMembersSearchConditionByJobId({ jobId: this.jobId })
          this.$emit('refresh')
        }
        this.fetchSearchConditions()
      })
    },
    fetchSearchCondition () {
      return this.$http.secured.get(`/scout/view/scouts/search_conditions/${this.searchCondition.id}`)
    },
    fetchSearchConditions () {
      this.$emit('fetchSearchConditions')
    },
    otherJobCopy () {
      this.$http.secured.post(`/scout/view/scouts/search_conditions/${this.searchCondition.id}/_copy/${this.copyToJobId}`).then((response) => {
        if (!Number(this.jobBy(this.contractId, this.copyToJobId).searchConditionId)) {
          this.$store.dispatch('contracts/setSearchConditionId', { value: response.data, jobId: this.copyToJobId })
        }
        this.$toasted.global.success({ message: '検索条件をコピーしました。' })
        this.modal.close()
      })
    },
    toggle () {
      this.isOpen = !this.isOpen
    },
    close () {
      this.isOpen = false
    },
    responseMappingSearchCondition (data) {
      return {
        id: data.id,
        name: data.name,
        parameter: data.parameter,
        condition: data.condition ? JSON.parse(data.condition) : createDefaultCondition(data.parameter)
      }
    },
    showModal () {
      if (!this.modal) {
        this.modal = new Foundation.Reveal(jQuery(`#other-copy-modal-${this.searchCondition.id}`), { closeOnClick: false })
      }
      this.modal.open()
    },
    closeReveal () {
      this.modal.close()
    },
    doRemove () {
      this.$dialog.confirm('削除しますか？')
        // はいを押下した時
        .then(() => {
          this.remove()
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    },
    ...mapActions([
      'deleteMembersSearchConditionByJobId'
    ])
  }

}
</script>
